<template>
  <div>
    <div class="mb-4 flex flex-wrap lg:flex-nowrap justify-between">
      <h1 class="mr-3 text-2xl text-gray-777 font-roboto uppercase">Consulta Online</h1>
      <div class="mt-6 sm:mt-0">
        <button v-if="!this.appointmentStore.show_note" class="flex items-end font-roboto font-medium btn-primary uppercase" @click.prevent="addNote" :disabled="!this.appointmentStore.appointment?.id" :title="!this.appointmentStore.appointment?.id ? 'Você não está em uma consulta' : ''">
          <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-2" />Adicionar Anotação
        </button>
        <div v-if="!this.appointmentStore.appointment?.id" class="block w-full mt-2 text-center text-sm sm:hidden">Você não está em uma consulta</div>
      </div>
    </div>
    <template v-if="this.appointmentStore.show_note">
      <div class="flex flex-wrap border rounded-lg p-6">
        <div class="w-full text-gray-777 font-roboto uppercase">Adicionar Anotação</div>
        <textarea-input v-model="item.note" :error="item.errors.note" class="mt-6 min-h-[150px] w-full" label="Anotações" />
        <div class="w-full flex justify-end mt-6">
          <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="resetForm">Cancelar</button>
          <loading-button :loading="processing" class="btn-primary px-6 py-2.5 text-xs leading-tight uppercase ml-1" @click.prevent="submit" type="submit">Salvar</loading-button>
        </div>
      </div>
    </template>
    <data-table
      v-if="loadTable"
      v-model:columns="columns"
      :disable-search="true"
      :route="'/patients/online-consultation/' + patient.id"
      no-data-label="Nenhuma anotação cadastrada"
      no-result-label="Nenhuma anotação encontrada"
    >
    </data-table>
  </div>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import DataTable from '@/Shared/Components/DataTable'
import TextareaInput from '@/Shared/Fields/TextareaInput'
import LoadingButton from '@/Shared/Components/LoadingButton'
import { useAppointmentStore } from '@/Store/Appointment'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
  inject: ['patient'],
  components: {
    DataTable,
    TextareaInput,
    LoadingButton,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  mounted () {
    this.item.note = this.appointmentStore.note
    this.item = useForm(this.item);
  },
  watch: {
    'item.note'(newValue, oldValue) {
      this.appointmentStore.note = newValue;
    }
  },
  methods: {
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    resetForm() {
      this.appointmentStore.show_note = false;
      this.item.note = '';
      this.item.errors = {};
    },
    addNote() {
      this.appointmentStore.show_note = true;
    },
    submit() {
      this.item.appointment_id = this.appointmentStore.appointment.id;
      this.item.post(`/patients/online-consultation/note/${this.patient.id}`, {
        preserveState: true,
        preserveScroll: true,
        onFinish: () => {
          if(!Object.keys(this.item.errors).length) {
            this.resetForm();
            this.reloadTable();
            this.appointmentStore.show_note = false;
          } else {
            this.processing = false;
          }
        }
      });
    }
  },
  data() {
    return {
      item: {
        note: '',
        appointment_id: '',
        errors: {}
      },
      processing: false,
      appointmentStore: useAppointmentStore(),
      loadTable: true,
      appointment: {},
      columns: [
        {
          uniqid: 'date_start',
          label: 'Atendimento',
          field: 'date_start',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'p-3 border-b text-sm w-[150px] align-top',
          headerClass: 'px-2 py-4 text-left w-[150px]',
          format: (val, row) => this.$filters.formatDateTime(row.appointment.date_start),
        },
        {
          uniqid: 'date',
          label: 'Horário da Anotação',
          field: 'date',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'p-3 border-b text-sm w-[180px] align-top',
          headerClass: 'px-2 py-4 text-left w-[180px]',
          format: (val, row) => this.$filters.formatDateTime(row.date, 'HH:mm'),
        },
        {
          uniqid: 'note',
          label: 'Anotações',
          field: 'note',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-pre-wrap',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${val}`
        },
      ],
    }
  },
}
</script>